import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
//import { SharedModule } from '@app/shared/shared.module';

import { SearchDetailsComponent } from './components/search-details/search-details.component';
import { SearchGanttComponent } from './components/search-gantt/search-gantt.component';
import { SearchFiltersComponent } from './components/search-filters/search-filters.component';
import { SinceFiltersComponent } from './components/since-filters/since-filters.component';
import { SearchViewsComponent } from './components/search-views/search-views.component';
import { DerivativesSearchComponent } from './components/derivatives-search/derivatives-search.component';
import { DerivativeSearchContainerComponent } from './views/derivative-search-container.component';
import { IntroducedContainerComponent } from './views/introduced-container.component';
import { SimilarVehicleComponent } from './views/similar-vehicle.component';
import { DetailsComponent } from './components/details/details.component'; 
import { DetailsSinceComponent } from './components/details-since/details-since.component'; 
import { SimilarComponent } from './components/similar/similar.component';
import { LinkedComponent } from './components/linked/linked.component';

import { CbTriStateComponent } from './components/cb-tri-state/cb-tri-state.component';

import { SearchFilterService } from './service/search-filter.service';
import { SearchConverterService } from './service/search-converter.service';
import { SimilarVehicleService } from './service/similar-vehicle.service';

// Third Party
import { LoadingModule } from 'ngx-loading';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button'; 
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { GanttAllModule } from '@syncfusion/ej2-angular-gantt';
import { TabModule } from '@syncfusion/ej2-angular-navigations';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@NgModule({
  declarations: [
    DerivativeSearchContainerComponent,
    IntroducedContainerComponent,
    SearchDetailsComponent, SearchGanttComponent,
    SearchFiltersComponent,
    SinceFiltersComponent,
    SearchViewsComponent,
    DerivativesSearchComponent,
    CbTriStateComponent,
    SimilarVehicleComponent,
    DetailsComponent,
    DetailsSinceComponent,
    SimilarComponent,
    LinkedComponent
  ],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, RouterModule, // SharedModule,
    LoadingModule,
    TranslateModule,
    PopoverModule.forRoot(), PaginationModule.forRoot(),
    ScrollingModule,
    MatButtonModule, MatButtonToggleModule, MatTooltipModule, MatDatepickerModule, MatInputModule, MatSelectModule,
    GanttAllModule, TabModule, GridAllModule, DropDownListModule
  ],
  providers: [
    SearchFilterService,// keep it local
    SearchConverterService,
    SimilarVehicleService,// keep it local
  ],
  exports: [// only nexts are public
    DerivativeSearchContainerComponent, 
    IntroducedContainerComponent,
    SimilarVehicleComponent
  ]
})
export class VehicleSearchModule {
  constructor(private translate: TranslateService) {
    //translate.get('HELLO', { value: 'world' }).subscribe((res: string) => {
    //  console.log('Translate VehicleSearchModule', res);
    //});
  }
}
